import * as types from "./actionTypes";

const initialState = {
  userData: {},
  loginUserStatus: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_USER: {
      return {
        ...state,
        loginUserStatus: false,
      };
    }
    case types.LOGIN_USER_SUCCESS: {
      return {
        ...state,
        userData: action.payload.data,
        loginUserStatus: action.payload.success,
      };
    }
    case types.LOGIN_USER_FAILED: {
      return {
        ...state,
        userData: action.payload,
        loginUserStatus: action.payload.success,
      };
    }
    case types.LOGOUT_USER_SUCCESS: {
      return {
        ...state,
        userData: {},
        loginUserStatus: false,
      };
    }
    case types.LOGOUT_USER_FAILED: {
      return {
        ...state,
        userData: action.payload,
      };
    }
    default:
      return initialState;
  }
};

export default authReducer;
